import {atom, AtomEffect, DefaultValue, selector} from "recoil";
import {MobileGroupName} from "../types/MobileTabs";

interface AtomStateMobileTab {
    isActive: boolean,
    tabId: MobileGroupName | null,
}

const onChangeEffect = (): AtomEffect<AtomStateMobileTab> => ({onSet}) => {
    onSet((newValue, oldValue) => {
        if (!(oldValue instanceof DefaultValue)) {

            newValue.isActive
                ? window.scrollbar.lock()
                : window.scrollbar.unlock();
        }
    });
};

export const stateMobileDrawer = atom<AtomStateMobileTab>({
    key: 'mobileTabs',
    default: {
        tabId: null,
        isActive: false,
    },
    effects: [
        onChangeEffect(),
    ],
});


export const stateMobileDrawerTabId = selector<MobileGroupName | null>({
    key: 'mobileDrawerTabId',
    get: ({get}) => {
        const state = get(stateMobileDrawer);

        return state.tabId;
    },
    set: ({set}, tabId) => {
        set(
            stateMobileDrawer,
            (prevValue) => tabId instanceof DefaultValue ? tabId : ({...prevValue, tabId})
        );
    }
})


export const stateMobileDrawerIsActive = selector<boolean>({
    key: 'mobileDrawerIdActive',
    get: ({get}) => {
        const state = get(stateMobileDrawer);

        return state.isActive || false;
    },
    set: ({set}, isActive) => {
        set(
            stateMobileDrawer,
            (prevValue) => isActive instanceof DefaultValue ? isActive : ({...prevValue, isActive})
        );
    }
})
